export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

export const AUTH0_CONFIG = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
  redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || `${window.location.origin}/callback`,
};

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';

export const PAGINATION_DEFAULT = {
  page: 1,
  per_page: 20,
};
